<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Global Settings</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Global Settings</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSGlobalSettingList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  
                  <li><strong>ID</strong> {{ value.id }}</li>
                  
                  <li><strong>Site Title</strong> {{ value.site_title }}</li>
                  
                  <li><strong>Tag Line</strong> {{ value.tag_line }}</li>
                  
                  <li><strong>Home Page</strong> 
                      <span v-if="!_.isNil(value.home_page)">{{ pre.home_page[value.home_page] }}</span>
                    </li>
                  
                  <li><strong>Logo</strong> 
                      <img v-bind:src="API_ASSET_UPLOAD_URL+value.logo_path" class="img-fluid img-thumbnail rounded" style="width: 200px;">
                      </li>
                  
                  <li><strong>Template</strong> 
                      <span v-if="!_.isNil(value.template)">{{ pre.template[value.template] }}</span>
                    </li>
                  
                  <li><strong>Header Scripts</strong> {{ value.header_scripts }}</li>
                  
                  <li><strong>Footer Scripts</strong> {{ value.footer_scripts }}</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "CMSGlobalSettingShow",
  metaInfo: {
    title: "CMS Global Settings | Dotlines"
  },
  data: () => ({
    value: {
      
    },
    pre: {
      home_page: [],template: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    homePageOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    templateOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/2")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.homePageOptions().then(home_page => {
        this.pre.home_page = home_page;
      });
      await this.templateOptions().then(template => {
        this.pre.template = template;
      });
      

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_global_settings/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
        